const tabInit = () => {
	const commentaryTab = document.querySelector(".js-commentary");
	const viewTab = document.querySelector(".js-views");
	const viewAssetClasses = document.querySelector(".js-asset-class-views");
	const weeklyCommentary = document.querySelector(".js-weekly-commentary");
	const firstTab = document.querySelector(".js-first-tab-open");
	const secondTab = document.querySelector(".js-second-tab-open");

	if (viewTab) {
		viewTab.addEventListener("click", () => {
			viewAssetClasses.classList.remove("hidden");
			weeklyCommentary.classList.add("hidden");
			secondTab.classList.add("md:block");
			firstTab.classList.remove("md:block");
		});
	}

	if (commentaryTab) {
		commentaryTab.addEventListener("click", () => {
			viewAssetClasses.classList.add("hidden");
			weeklyCommentary.classList.remove("hidden");
			secondTab.classList.remove("md:block");
			firstTab.classList.add("md:block");
		});
	}
};
tabInit();
